module.exports = __webpack_public_path__ + "static/media/34.3a820bb2.jpg";